"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataItem_1 = require("../common/base/DataItem");
var ComputeVariablesFunction_1 = require("./ComputeVariablesFunction");
var Field_1 = require("../../constants/Field");
var DataType_1 = require("../common/base/DataType");
var lodash_1 = require("lodash");
var DeepCopy_1 = require("../common/lib/DeepCopy");
var ComputeVariables = /** @class */ (function () {
    function ComputeVariables() {
        this.statusEntries = ["OK", "Error", "Inhibited"];
        this.status = new DataItem_1.DataItem(Field_1.FIELD.STATUS, DataType_1.DataType.string);
        this.status.enum = this.statusEntries;
        this.functions = [];
    }
    ComputeVariables.fromJson = function (json) {
        var clone = DeepCopy_1.deepCopy(json);
        var computeVariables = new ComputeVariables();
        if (clone[Field_1.FIELD.SEVERITY]) {
            computeVariables.severity = DataItem_1.DataItem.fromJson(Field_1.FIELD.SEVERITY, clone[Field_1.FIELD.SEVERITY]);
        }
        delete clone[Field_1.FIELD.SEVERITY];
        var functions = lodash_1.map(Object.keys(clone), function (functionName) {
            return ComputeVariablesFunction_1.ComputeVariablesFunction.fromJson(functionName, clone[functionName]);
        });
        computeVariables.functions = functions;
        return computeVariables;
    };
    /**
     * To be used instead of fromJson() when sceModel.variables is undefined
     * @param functionsJson properties.functions json
     */
    ComputeVariables.initFromFunctions = function (functionsJson) {
        var functions = lodash_1.map(Object.keys(functionsJson), function (functionName) {
            var clone = DeepCopy_1.deepCopy(functionsJson[functionName]);
            delete clone[Field_1.FIELD.OUTPUTS];
            return ComputeVariablesFunction_1.ComputeVariablesFunction.fromJson(functionName, clone);
        });
        var computeVariables = new ComputeVariables();
        computeVariables.functions = functions;
        return computeVariables;
    };
    // public updateConditionsFromComputeFunctions(computeFunctions: ComputeFunction[]) {
    //     map(computeFunctions, computeFunction => {
    //         const computeVariablesFunction = find(this.functions, { name: computeFunction.name });
    //         if (computeVariablesFunction) {
    //             computeVariablesFunction.updateConditionsFromComputeFunction(computeFunction);
    //         }
    //     })
    // }
    ComputeVariables.prototype.updateFunctionsFromComputeFunctionsJson = function (computeFunctions) {
        var _this = this;
        lodash_1.map(Object.keys(computeFunctions), function (computeFunctionName) {
            var computeVariablesFunction = lodash_1.find(_this.functions, { name: computeFunctionName });
            if (!computeVariablesFunction) {
                var clone = DeepCopy_1.deepCopy(computeFunctions[computeFunctionName]);
                delete clone[Field_1.FIELD.OUTPUTS];
                var computeFunction = ComputeVariablesFunction_1.ComputeVariablesFunction.fromJson(computeFunctionName, clone);
                _this.functions.push(computeFunction);
            }
        });
    };
    ComputeVariables.prototype.toJson = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.STATUS] = this.status.toJson(false);
        if (this.severity) {
            json[Field_1.FIELD.SEVERITY] = this.severity.toJson(false);
        }
        lodash_1.map(this.functions, function (varFunction) {
            json[varFunction.name.replace(/\s/g, '')] = varFunction.toJson();
        });
        return json;
    };
    return ComputeVariables;
}());
exports.ComputeVariables = ComputeVariables;
//# sourceMappingURL=ComputeVariables.js.map